import { Card, CloseButton } from 'react-bootstrap';
import React, { useEffect, useState, Suspense } from 'react';
import { hasError, hasKey, arrayIsEmpty } from '../helper';
import services from './../services';
import { debounce } from 'lodash';

const LoadingComponent = React.lazy(() => import('./LoadingComponent'));
const EmptySecretsComponent = React.lazy(() =>
	import('./EmptySecretsComponent'),
);

const SecretsComponent = (props) => {
	const [secrets, setSecrets] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		const getSecrets = async () => {
			const res = await services.getSecrets();
			setSecrets(res?.data?.payload ?? []);
			setLoading(false);
		};
		getSecrets();
	}, []);
	useEffect(() => {
		hasKey(props.secret, 'secret')
			? setSecrets((p) => [props.secret, ...p])
			: '';
	}, [props.secret]);
	const deleteSecretsHandler = debounce(async (secretId) => {
		const res = await services.deleteSecret(secretId);
		if (!hasError(res?.status) && res?.data?.ok) {
			console.log(secrets, secretId);
			setSecrets(secrets.filter((v) => v._id !== secretId));
		}
	}, 900);

	return (
		<div
			style={{
				maxHeight: '210px',
				overflow: 'auto',
			}}
		>
			{arrayIsEmpty(secrets) && (
				<Suspense fallback={<div></div>}>
					<EmptySecretsComponent />
				</Suspense>
			)}
			{loading && (
				<Suspense fallback={<div></div>}>
					<LoadingComponent />
				</Suspense>
			)}
			{!loading &&
				secrets &&
				secrets.map((s, i) => {
					return (
						<div
							key={i}
							className='d-flex align-items-center justify-content-center'
						>
							<Card.Body className='single-secret-card-body px-0'>
								{s.secret}
							</Card.Body>
							<CloseButton
								className='mx-1'
								onClick={() => deleteSecretsHandler(s._id)}
							/>
						</div>
					);
				})}
		</div>
	);
};

export default SecretsComponent;
